<template>
  <div id="app">
    <div class="page-header">
      <router-link class="page-header-left" tag="div" to="/index">
        <img class="page-header-logo" src="./assets/images/icc-logo.jpg">
        <span
          class="page-header-title"
          :class="{ ' hidden-md-and-down': showNavigateBar }"
        >CC云链系统供应链管理平台</span>
      </router-link>
      <div v-if="showNavigateBar" class="page-header-center">
        <navigator />
      </div>
      <div class="page-header-right">
        <el-dropdown v-if="user" placement="bottom">
          <div class="user-container">
            <el-badge is-dot :hidden="!hasNewMessage">
              <avatar
                :username="user.contact"
                :src="user.avatarUrl"
                :size="40"
              />
            </el-badge>
            <span
              class="user-name"
              :class="{ 'hidden-md-and-down': showNavigateBar }"
            >{{ user.contact }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link tag="div" to="/profile">
              <el-dropdown-item icon="el-icon-user">个人中心</el-dropdown-item>
            </router-link>
            <el-dropdown-item
              tag="div"
              icon="el-icon-switch-button"
              @click.native="handleLogout"
            >退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <template v-else>
          <div class="page-header-right-actions">
            <router-link tag="a" to="/login" exact>用户登录</router-link>
            <router-link tag="a" to="/register" exact>用户注册</router-link>
          </div>
        </template>
      </div>
    </div>
    <div class="sticky-footer">
      <div class="sticky-footer-content">
        <router-view />
      </div>
      <div class="page-footer">
        <!-- <div class="page-footer-navigator">
          <template v-for="(item, index) in links">
            <a class="page-footer-navigator_item" :key='index' :href="item.url">{{ item.name }}</a>
          </template>
        </div> -->
        <!-- <pre class="page-footer-copyright">投标管理系统     一汇社群信息科技有限公司@所有版权2006-{{ new Date().getFullYear() }}</pre> -->
        <div>联系电话：0750-3394888</div>
        <div class="page-footer-copyright">
          一汇社群信息科技有限公司@所有版权2019-{{ new Date().getFullYear() }}
          <div>
            <a class="icp-footer" href="https://beian.miit.gov.cn" target="_blank">粤ICP备19153915号-2</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Navigator from '@/components/Navigator.vue'
import avatar from 'vue-avatar'
import { checkNewMessage } from '@/api'

export default {
  name: 'App',

  components: {
    Navigator,
    avatar
  },

  data() {
    return {
      navigator: [
        {
          path: '/index',
          title: '首页'
        },
        {
          path: '/bid/notice',
          title: '招标公告'
        },
        {
          path: '/bid/win',
          title: '中标公告'
        },
        {
          path: '/bid/preview',
          title: '招标预告'
        },
        {
          path: '/news',
          title: '最新咨询'
        },
        {
          path: '/download',
          title: '模板下载'
        }
      ],

      // links: [
      //   {
      //     name: '网站介绍',
      //     url: '',
      //   },
      //   {
      //     name: '联系方式',
      //     url: '',
      //   },
      //   {
      //     name: '服务条款',
      //     url: '',
      //   },
      //   {
      //     name: '诚聘英才',
      //     url: '',
      //   },
      //   {
      //     name: '广告服务',
      //     url: '',
      //   },
      //   {
      //     name: '友情链接',
      //     url: '',
      //   },
      //   {
      //     name: '网站地图',
      //     url: '',
      //   },
      // ]

      hasNewMessage: false
    }
  },

  computed: {
    ...mapState(['user']),

    showNavigateBar() {
      const routePath = [
        '/',
        '/login',
        '/register',
        '/forgetPassword',
        '/index'
      ] // 不需要展示的页面路径

      return !routePath.includes(this.currentRoutePath)
    },

    currentRoutePath() {
      return this.$route.path
    }
  },

  watch: {
    $route: {
      handler() {
        if (this.user) {
          this.checkNewMessage()
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions(['logout']),

    async checkNewMessage() {
      try {
        const res = await checkNewMessage()

        this.hasNewMessage = !!res.data
      } catch (error) {
        console.log('检测新消息失败：', error)
      }
    },

    handleLogout() {
      this.logout().then(res => {
        location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin mixin-border-left($borderHeight, $borderColor) {
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -20px;
    width: 1px;
    height: $borderHeight;
    background-color: $borderColor;
    transform: translateY(-50%);
    pointer-events: none;
  }
}

#app {
  display: flex;
  flex-direction: column;
  // min-width: 1200px;
  // min-height: 1080px;
  height: 100%;
  font-family: Microsoft YaHei, 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #333;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--header-height);
    min-height: var(--header-height);
    padding: 0 5%;
    background-color: #fff;
    .page-header-left {
      display: flex;
      align-items: center;
      font-size: 20px;
      cursor: pointer;
      .page-header-logo {
        width: 49px;
        height: 49px;
        border-radius: 50%;
        overflow: hidden;
      }
      .page-header-title {
        white-space: nowrap;
        margin: 0 0 0 15px;
      }
    }
    .page-header-center {
      margin: 0 30px;
    }
    .page-header-right {
      display: flex;
      align-items: center;
      font-size: 16px;
      .page-header-right-actions {
        white-space: nowrap;
        > a {
          position: relative;
          cursor: pointer;
          &:hover {
            color: #417EF7;
          }
          + a {
            margin: 0 0 0 41px;
            @include mixin-border-left(15px, #E0E0E0);
          }
        }
      }
      .user-container {
        display: flex;
        align-items: center;
        cursor: pointer;
        .user-name {
          font-size: 16px;
          margin: 0 0 0 10px;
        }
      }
    }
  }
  .sticky-footer {
    flex: 1 1 100%;
    .sticky-footer-content {
      display: inline-block;
      width: 100%;
      height: 100%;
      background-color: #F6F6F6;
      vertical-align: top;
    }
    .page-footer {
      position: relative;
      top: calc(0px - var(--footer-height));
      z-index: 1;
      display: flex;
      flex-flow: column wrap;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: var(--footer-height);
      color: #808080;
      border-top: 1px solid #EBEBEB;
      .page-footer-navigator {
        .page-footer-navigator_item {
          &:hover {
            color: #417EF7;
          }
          &:nth-child(n + 2) {
            position: relative;
            margin: 0 0 0 41px;
            @include mixin-border-left(16px, #848282);
          }
        }
      }
      .icp-footer {
        margin: 60px 25% 0;
      }
      .page-footer-copyright {
        margin: 15px 0 0;
      }
    }
  }
}

.page-content_wrapper {
  max-width: 1200px;
  border-radius: 4px;
  background-color: #fff;
  padding: 0 30px;
  margin: 10px auto 60px;
}
</style>
